"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagementPeriodPaymentStatus = void 0;
var ManagementPeriodPaymentStatus;
(function (ManagementPeriodPaymentStatus) {
    ManagementPeriodPaymentStatus["SCHEDULED"] = "SCHEDULED";
    ManagementPeriodPaymentStatus["EXECUTED"] = "EXECUTED";
    ManagementPeriodPaymentStatus["CANCELED"] = "CANCELED";
})(ManagementPeriodPaymentStatus = exports.ManagementPeriodPaymentStatus || (exports.ManagementPeriodPaymentStatus = {}));
//# sourceMappingURL=HlManagementPeriodPayment.js.map